"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiSendSupportMessage = void 0;
const client_1 = require("./client");
/**
 * Send a message to the support team.
 * @param fromEmail the email of the sender.
 * @param fromName the name of the sender.
 * @param text the text of the message.
 * @returns {void}
 */
const apiSendSupportMessage = async (fromEmail, fromName, text) => {
    const { userAgent } = window.navigator;
    const url = window.location.href;
    const { data } = await client_1.default.post('/api/send-support-message', {
        fromEmail,
        fromName,
        userAgent,
        url,
        text,
    });
    return data;
};
exports.apiSendSupportMessage = apiSendSupportMessage;
//# sourceMappingURL=support.js.map